module.exports = __webpack_public_path__ + "static/img/model-bg15.277d425.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg15.jpg
// module id = TXOM
// module chunks = 0